export default "__VITE_ASSET__1d957990__"